<template>
  <div>
    <div
      v-if="!updatingCard"
      @click="$emit('toggle-voucher', true)"
    >
      <paper-simple :class="{ disabled: !hasVoucher && focusEnabled }">
        <validation-provider
          #default="{ errors }"
          name="Voucher"
          :rules="hasVoucher ? 'required' : ''"
        >
          <input-field
            label="Voucher"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="voucher"
              v-model="voucher"
              :state="errors.length > 0 ? false : null"
              placeholder="Enter voucher here..."
            />
          </input-field>
        </validation-provider>
      </paper-simple>
    </div>

    <seperator v-if="!validVoucher && !updatingCard" />

    <div
      v-if="showCard"
      @click="$emit('toggle-voucher', false)"
    >
      <paper-simple :class="{ disabled: hasVoucher && focusEnabled }">
        <validation-provider
          #default="{ errors }"
          name="Card Name"
          :rules="{ required: !hasVoucher || !focusEnabled }"
        >
          <input-field
            label="Cardholder Name"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="cardName"
              v-model="name_card"
              :state="errors.length > 0 && (!hasVoucher || !focusEnabled) ? false : null"
              placeholder="Enter name here..."
            />
          </input-field>
        </validation-provider>

        <div class="card-details">
          <label for="card-element">Card</label>
          <div
            id="card-element"
            :class="{ error: cardError && !hasVoucher }"
          />
          <span
            v-if="!hasVoucher"
            class="text-danger small"
          >{{
            errorMessage
          }}</span>
        </div>
        <div class="secure">
          <div class="safe">
            <img
              :src="require('@/assets/svg/secure.svg')"
              class="secure-icon"
              alt="secure-icon"
            >
            <span>Safe & Secure</span>
          </div>
          <div class="stripe">
            <span>Powered by</span>
            <img
              :src="require('@/assets/svg/stripe-slate.svg')"
              class="img-fluid stripe-logo"
              alt="stripe logo"
            >
          </div>
        </div>
      </paper-simple>
    </div>
  </div>
</template>
<script>
import Seperator from '@/components/seperator/Seperator.vue'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import loadStripe from '@/services/loadStripe'

export default {
  name: 'PaymentForm',
  components: {
    Seperator,
    ValidationProvider,
  },
  props: {
    counter: {
      type: Number,
      required: true,
    },
    focused: {
      type: Boolean,
      required: true,
    },
    hasVoucher: {
      type: Boolean,
      required: true,
    },
    cardError: {
      type: Boolean,
      required: true,
    },
    updatingCard: {
      type: Boolean,
      default: false,
    },
    voucherValue: {
      type: String,
      default: null,
    },
    focusEnabled: {
      type: Boolean,
      default: false,
    },
    validVoucher: {
      type: Boolean,
      default: false,
    },
    showCard: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      required,
      errorMessage: null,
      name_card: '',
      voucher: '',
    }
  },
  computed: {
    getStripe() {
      return this.$store.state.stripe ? this.$store.state.stripe.stripe : null
    },
  },
  watch: {
    getStripe() {
      this.loadScript()
    },
    counter() {
      this.confirmCard()
    },
    voucher(val) {
      this.$emit('change-voucher', val)
    },
  },
  created() {
    this.voucher = this.voucherValue
  },
  mounted() {
    if (this.showCard) {
      if (this.getStripe === null) {
        loadStripe()
        return
      }
      this.loadScript()
    }
  },
  methods: {
    loadScript() {
      const elements = this.$store.state.stripe.stripe.elements()

      const inputStyle = {
        base: {
          fontSize: '14px',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#8e8e8e',
          },
        },
      }

      this.cardElement = elements.create('card', { style: inputStyle })
      this.cardElement.mount('#card-element')

      this.cardElement.on('change', event => {
        this.$emit('change-focus', true)
        if (event.error) {
          this.errorMessage = event.error.message
          this.$emit('card-error', true)
        } else {
          this.$emit('card-error', false)
          this.errorMessage = ''
        }

        if (event.empty) {
          this.$emit('change-focus', false)
        }
      })
    },

    confirmCard() {
      const { clientSecret } = this.$store.state.payments
      this.$store.state.stripe.stripe
        .confirmCardSetup(clientSecret, {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              name: this.name_card,
            },
          },
        })
        .then(result => {
          if (result.error) {
            this.errorToast(result.error.message)
            this.$store.commit('app/TOGGLE_OVERLAY', false)
            this.$emit('card-error', true)
            return
          }
          this.$emit('card-confirmed', true)
        })
        .catch(error => {
          console.log(error)
          this.$emit('card-error', true)
          this.$store.commit('app/TOGGLE_OVERLAY', false)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.stripe-input {
  padding: 0.438rem 1rem;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.25rem;
}

.card-details {
  margin-top: 24px;
  #card-element {
    background: #ffffff;
    padding: 12px 10px;
    border: 1px solid #e0e5eb;
    border-radius: 0.25rem;
    &.error {
      border-color: #e34850;
    }
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.secure {
  display: flex;
  .safe {
    display: flex;
    width: 100%;
    align-items: center;
    img {
      margin-right: 10px;
      width: 20px;
    }
  }

  .stripe {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    .stripe-logo {
      max-width: 100px;
    }
  }
}
</style>
